export const isProduction = (): boolean => {
  return (
    window.location.host.includes('wallcheck.dob.dc.gov') ||
    window.location.host.includes('wallcheck-dob-prod')
  );
};
